import { Component, Input } from '@angular/core';

import { SpinnerPositionType } from './spinner-position-type.enum';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent {
    get visible() {
        return this._value;
    }

    @Input()
    set visible(value: boolean) {
        if (!this.delay) {
            this._value = value;
            return;
        }
        if (value) {
            this.delayTimeout = setTimeout(() => {
                this._value = true;
            }, this.delay);
        } else {
            this._value = false;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = null;
            }
        }
    }
    @Input() public height: number;
    @Input() public overlay: boolean;
    @Input() public overlayRounded: boolean;
    @Input() public position = SpinnerPositionType.Center;
    @Input() public delay: number;
    @Input() public infoText: string;

    private _value: boolean;
    private delayTimeout: any;

    public getSpinnerPositionClass(): string {
        switch (this.position) {
            case SpinnerPositionType.Center:
                return 'spinner-center';
            case SpinnerPositionType.Top:
                return 'spinner-top';
            case SpinnerPositionType.Bottom:
                return 'spinner-bottom';
        }
    }
}
